function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("image", {
  id: "image0",
  width: 24,
  height: 24,
  x: 0,
  y: 0,
  href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElN RQfjAgwEFzfWJaYRAAAAiUlEQVQ4y+3Suw2DMBSF4d8OQ7inRYrZIfIMcXqWRBmCBehBYodQ8DAi 2L59chq7+I6u/IB/ojHb5ibidxo0PYAWcR+cEvAXijetrGDxR54rfPF04YKHW9I8KRhyHIp1raix QJfmYcKIoqRiYkjx48P1e8XE+fnQjgcfiPPz11imJPhVHE6OfyQzAWIf5W+O+OsAAAAldEVYdGRh dGU6Y3JlYXRlADIwMTktMDItMTJUMTE6MjM6NTUtMDc6MDACNDWIAAAAJXRFWHRkYXRlOm1vZGlm eQAyMDE5LTAyLTEyVDExOjIzOjU1LTA3OjAwc2mNNAAAAABJRU5ErkJggg=="
});

function SvgIcAnnotationApplyRedactBlack24Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAnnotationApplyRedactBlack24Px);
export default __webpack_public_path__ + "static/media/ic_annotation_apply_redact_black_24px.be028fb8.svg";
export { ForwardRef as ReactComponent };